import React from 'react';
import { parseKickContent, truncateKickContent } from '../lib/kickContent';

// A chat message: emotes as images, URLs as links
export function renderMessageContent(content) {
  if (!content) return null;
  return parseKickContent(content).map((piece, i) => {
    if (piece.type === 'emote') {
      return <img key={i} src={piece.url} alt={piece.name} title={piece.name} className="message-emote" />;
    }
    if (piece.type === 'link') {
      return (
        <a key={i} href={piece.url} target="_blank" rel="noopener noreferrer">
          {piece.url}
        </a>
      );
    }
    // A space after every text piece keeps adjacent emotes apart (they only have a 1px margin)
    return piece.text + ' ';
  });
}

// A reply preview cut to maxLength characters, with "..." when cut.
// emoteProps sets the emote <img> className/style, which differ between the feed and the editor.
export function renderTruncatedContent(content, maxLength, emoteProps) {
  if (!content) return null;
  const { pieces, truncated } = truncateKickContent(parseKickContent(content, { links: false }), maxLength);
  return (
    <>
      {pieces.map((piece, i) =>
        piece.type === 'emote'
          ? <img key={i} src={piece.url} alt={piece.name} title={piece.name} {...emoteProps} />
          : piece.text
      )}
      {truncated && '...'}
    </>
  );
}
